module.exports = __webpack_public_path__ + "img/桦桦数控.ea765a03.png";